import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { stringUtil } from "../../utilities/string";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
  charge: yup.boolean().required(),
  isAdditionalProvider: yup.boolean().notRequired(),
  notification: yup
    .object({
      type: yup.string().required(),
      body: yup.string().required(),
      subject: yup.string().required(),
      bodySms: yup.string().required(),
      successMessage: yup.string().required(),
    })
    .nullable(),
});

export function useCancelAppointmentMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      const req = requestSchema.validateSync(payload, { strict: true });

      const notification = req.isAdditionalProvider
        ? {}
        : {
            notification_type: req.notification.type,
            notification_body: stringUtil.toBase64(req.notification.body),
            appointment_sms: stringUtil.toBase64(req.notification.bodySms),
            appointment_subject: req.notification.subject,
            success_msg: req.notification.successMessage,
          };

      return http.post(HTTP_ENDPOINTS.appointments.cancel(req.appointmentId), {
        pat_to_be_charged: req.isAdditionalProvider ? false : req.charge,
        appointment_id: req.appointmentId,
        cancel_all: !req.isAdditionalProvider,
        ...notification,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
